import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { setUserPool } from '../actions/pool';
import { poolLabel } from '../Components/Constants/static';
import { AiFillHome } from 'react-icons/ai';

const AppInfo = () => {
	const { user, poolAccess, superAdmin } = useSelector((state) => state.account);
	const { userPool } = useSelector((state) => state.pool);
	const dispatch = useDispatch();
	let poolAccessLen = poolAccess && poolAccess.length;

	return (
		<div className='appInfo'>
			<div
				style={{
					fontSize: '20px',
					textDecoration: 'none',
					fontFamily: 'monospace',
				}}>
				Doorkeeper&nbsp;
				<Link
					to={{ pathname: `/` }}
					onClick={() => {
						if(poolAccessLen > 1 || superAdmin) dispatch(setUserPool(''));
					}}
					style={{ color: 'white' }}>
					<AiFillHome />
				</Link>
			</div>
			{user && (
				<div className='userInfo'>
					<div
						style={{
							fontSize: '15px',
							fontWeight: '600',
							color: '#fff',
							fontFamily: 'monospace',
						}}>
						User:
						<em>
							&nbsp;{user['given_name']} {user['family_name']}&nbsp;&nbsp;
						</em>
					</div>
					{userPool && (
						<>
							<div style={{ fontFamily: 'monospace', fontSize: '15px' }}>
								Userpool:
								<Link to={{ pathname: `/` }}>{' ' + poolLabel[userPool]}</Link>
							</div>
							&nbsp;
						</>
					)}
				</div>
			)}
		</div>
	);
};

export default AppInfo;
